import { render, staticRenderFns } from "./NavBarStyle3.vue?vue&type=template&id=5244d841&"
import script from "./NavBarStyle3.vue?vue&type=script&lang=js&"
export * from "./NavBarStyle3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports